package com.tovtalk.ui.navigation

import androidx.navigation.NavBackStackEntry
import androidx.savedstate.read

actual fun getNavArgString(entry: NavBackStackEntry, key: String): String? {
    val args = entry.arguments ?: return null
    return args.read { getStringOrNull(key) }
}

actual fun getNavArgInt(entry: NavBackStackEntry, key: String): Int? {
    val args = entry.arguments ?: return null
    return args.read { getIntOrNull(key) }
        ?: args.read { getStringOrNull(key) }?.toIntOrNull()
}
